import MarkPriceDisplay from 'src/components/MarketStatsBar/MarkPriceDisplay';
import { PriceChangePercentDisplay } from 'src/components/MarketStatsBar/PriceChangePercentDisplay';
import useCurrentMarketMarkPrice from 'src/hooks/useCurrentMarketMarkPrice';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';

/**
 * Mark price and 24hr % change displayed within the market selector trigger on mobile.
 */
export default function MarketSelectorPriceDisplay() {
	const currentlySelectedMarket = useDriftStore(
		(s) => s.selectedMarket.current
	);
	const markPrice = useCurrentMarketMarkPrice();

	return (
		<div className="flex items-center gap-x-sm">
			<MarkPriceDisplay
				price={markPrice.toString()}
				loading={markPrice.eqZero()}
				className="w-auto typo-heading-h5 md:typo-heading-h4"
			/>
			<PriceChangePercentDisplay
				marketId={currentlySelectedMarket?.marketId}
				markPrice={markPrice}
				className="typo-body-2xs"
				withBackground
			/>
		</div>
	);
}
